/*
 * IMPORTS
 */
import React from "react"; // Npm: react.js library.

/*
 * OBJECTS
 */
const DEFAULT_AUDIO_SOURCE = "/audio/low-credit-warning.mp3";

const Index = React.forwardRef(
  (
    {
      duration = 4000,
      source = DEFAULT_AUDIO_SOURCE,
      volume = 1,
    },
    ref,
  ) => {
    // Hook assignment.
    const _audioRef = React.useRef(null);
    const _sourceRef = React.useRef(null);
    const _timeoutRef = React.useRef(null);
    const _isPlayingRef = React.useRef(false);

    // Event handler.
    const _Stop = React.useCallback(() => {
      if (_timeoutRef.current) clearTimeout(_timeoutRef.current);

      _timeoutRef.current = null;
      _isPlayingRef.current = false;

      if (_audioRef.current) {
        _audioRef.current.pause();
        _audioRef.current.currentTime = 0;
      }
    }, []);

    const _Play = React.useCallback(() => {
      if ("undefined" === typeof window || _isPlayingRef.current) return;

      try {
        if (!_audioRef.current || _sourceRef.current !== source) {
          _audioRef.current = new Audio(source);
          _audioRef.current.preload = "auto";
          _sourceRef.current = source;
        }

        _audioRef.current.currentTime = 0;
        _audioRef.current.volume = volume;
        _isPlayingRef.current = true;
        _timeoutRef.current = setTimeout(_Stop, duration);

        _audioRef.current.play().catch((error) => {
          _Stop();
          console.warn("Unable to play warning audio.", error);
        });
      } catch (error) {
        _Stop();
        console.warn("Unable to play warning audio.", error);
      }
    }, [_Stop, duration, source, volume]);

    React.useImperativeHandle(ref, () => ({
      play: _Play,
      stop: _Stop,
    }), [_Play, _Stop]);

    React.useEffect(() => _Stop, [_Stop]);

    return null;
  },
);

Index.displayName = "WarningAudio";

/*
 * EXPORTS
 */
export default React.memo(Index);
